var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.002,
    height: 18.998,
    viewBox: "0 0 19.002 18.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "NewIcon",
    d: "M19105,1743.5V1737h-6.5a1.5,1.5,0,1,1,0-3h6.5v-6.5a1.5,1.5,0,1,1,3,0v6.5h6.5a1.5,1.5,0,0,1,0,3h-6.5v6.5a1.5,1.5,0,0,1-3,0Z",
    transform: "translate(-19096.998 -1726.001)",
    fill: "#f8f8f8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.3d32695a2aa9abb82bf37bd219d5b5be.svg";
export { ForwardRef as ReactComponent };